import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, renderSlot as _renderSlot, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "bg-primary-gradient" }
const _hoisted_2 = { class: "h-screen overflow-y-auto bg-image-group bg-no-repeat bg-cover p-3 sm:p-0" }
const _hoisted_3 = { class: "w-full mx-auto max-w-2xl sm:py-5 relative z-0 visible" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", {
        class: _normalizeClass(["flex items-center relative bg-no-repeat", ['bg-image-iphones']])
      }, [
        _createVNode(_Transition, {
          name: "fade",
          mode: "out-in",
          duration: 300
        }, {
          default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
            _createElementVNode("div", { class: "h-screen hidden lg:flex px-8 flex-col w-2/4 items-center justify-center" }, [
              _createElementVNode("div", null, [
                _createElementVNode("h1", { class: "headline1" }, " Superprático é "),
                _createElementVNode("h1", { class: "headline1" }, [
                  _createTextVNode(" a "),
                  _createElementVNode("span", { class: "text-neutral-900" }, "plataforma ")
                ]),
                _createElementVNode("h1", { class: "headline1" }, [
                  _createElementVNode("span", { class: "text-neutral-900" }, "completa"),
                  _createElementVNode("span", { class: "headline1 mb-4" }, " para ")
                ]),
                _createElementVNode("h1", { class: "headline1 mb-4" }, " formação de "),
                _createElementVNode("h1", { class: "headline1 mb-4" }, " condutores "),
                _createElementVNode("p", { class: "headline3" }, " Atua em todas etapas do "),
                _createElementVNode("p", { class: "headline3" }, " processo para certificar o "),
                _createElementVNode("p", { class: "headline3" }, " cumprimento da legislação ")
              ])
            ], -1)
          ]))]),
          _: 1
        }),
        _createElementVNode("div", _hoisted_3, [
          _renderSlot(_ctx.$slots, "default", {}, undefined, true)
        ]),
        _cache[1] || (_cache[1] = _createElementVNode("div", { class: "hidden lg:flex w-2/4" }, null, -1))
      ])
    ])
  ]))
}